import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Logo } from "../components/AppShell";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { vendorRegister, formatErr } from "../lib/api";
import { toast } from "sonner";

export default function VendorRegister() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", phone_bizum: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) { toast.error("La contraseña debe tener al menos 6 caracteres"); return; }
    setLoading(true);
    try {
      const res = await vendorRegister(form);
      localStorage.setItem("el_vendor_token", res.access_token);
      toast.success("¡Cuenta creada!");
      navigate("/vendedores/panel");
    } catch (err) { toast.error(formatErr(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="wizard-shell">
      <div className="wizard-frame fade-in">
        <header className="px-5 py-4 border-b border-slate-100">
          <Logo size={32} withWordmark />
        </header>
        <main className="flex-1 px-5 py-8 flex flex-col justify-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-slate-50 border border-slate-200 w-fit">
            <span className="text-xs font-semibold text-slate-700">Nuevo vendedor</span>
          </div>
          <h1 className="mt-3 text-3xl font-[Outfit] font-extrabold tracking-tight text-slate-900">
            Crea tu cuenta
          </h1>
          <p className="text-sm text-slate-600 mt-1">
            Empieza a recomendar clientes y gana el 50% de comisión por cada venta.
          </p>

          <button onClick={() => {
            // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
            const redirectUrl = window.location.origin + "/vendedores/auth-callback";
            window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
          }}
            className="mt-6 h-12 w-full rounded-xl bg-white border border-slate-200 hover:bg-slate-50 flex items-center justify-center gap-2.5 font-semibold text-slate-800 active:scale-[0.99] transition"
            data-testid="btn-google-signup">
            <svg width="18" height="18" viewBox="0 0 18 18"><g fill="none" fillRule="evenodd"><path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z" fill="#4285F4"/><path d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z" fill="#34A853"/><path d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z" fill="#FBBC05"/><path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z" fill="#EA4335"/></g></svg>
            Continuar con Google
          </button>

          <div className="my-4 flex items-center gap-3">
            <div className="flex-1 h-px bg-slate-200" />
            <span className="text-[10px] tracking-[0.25em] uppercase text-slate-400 font-semibold">o con email</span>
            <div className="flex-1 h-px bg-slate-200" />
          </div>

          <form onSubmit={submit} className="space-y-3.5" data-testid="vendor-register-form">
            <div className="space-y-1.5">
              <Label className="text-sm">Nombre</Label>
              <Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
                placeholder="Tu nombre" data-testid="input-reg-name" required />
            </div>
            <div className="space-y-1.5">
              <Label className="text-sm">Email</Label>
              <Input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
                placeholder="tu@email.com" data-testid="input-reg-email" required />
            </div>
            <div className="space-y-1.5">
              <Label className="text-sm">Contraseña</Label>
              <Input type="password" value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                placeholder="Mínimo 6 caracteres" data-testid="input-reg-password" required />
            </div>
            <div className="space-y-1.5">
              <Label className="text-sm">Teléfono para Bizum (opcional)</Label>
              <Input value={form.phone_bizum}
                onChange={(e) => setForm({ ...form, phone_bizum: e.target.value })}
                placeholder="+34 600 000 000" data-testid="input-reg-bizum" />
            </div>
            <Button type="submit" disabled={loading}
              className="btn-primary h-12 rounded-xl w-full font-semibold"
              data-testid="btn-vendor-register">
              {loading ? "Creando cuenta..." : "Crear cuenta"}
            </Button>
            <button type="button" onClick={() => navigate("/vendedores/login")}
              className="block mx-auto text-sm text-slate-600 underline underline-offset-4"
              data-testid="link-to-login">
              Ya tengo cuenta
            </button>
          </form>
        </main>
      </div>
    </div>
  );
}
